import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';

import EmailInput from './login-form/email-input';
import PasswordInput from './login-form/password-input';
import NavbarLink from '../navbar-link';

import { validateSignInRequest } from '../../../tools/validation/auth/sign-in-request-validation';

const validate = values => {
  let { errors } = validateSignInRequest(values);
  let validationErrors = {};

  errors.forEach(error => {
    validationErrors[error.property] = error.message;
  });

  return validationErrors;
};

class NavbarLoginForm extends Component {
  renderForgotPasswordLink() {
    return (
      <NavbarLink to="/forgot-password" className="navbar__forgot-password">
        Forgot Password?
      </NavbarLink>
    );
  }

  render() {
    const { isUserLoading, handleSubmit, pathname } = this.props;

    if (isUserLoading) {
      return <p className="pull-right navbar-text">Signing In...</p>;
    }

    if (/^\/sign-in($|\/$)/.test(pathname) || /^\/public\/schools\/\d+\/vacancies\/\d+/.test(pathname)) {
        return null;
    }

    return (
      <div>
        <Nav pullRight className="hidden-xs hidden-sm">
          {this.renderForgotPasswordLink()}
        </Nav>
        <Navbar.Form pullRight className="hidden-xs">
          <form onSubmit={handleSubmit}>
            <Field name="email" component={EmailInput} />
            <Field name="password" component={PasswordInput} />
            <button type="submit" className="btn btn-basic btn_log-in">
              <i className="i-apli-log-in" />
              <span className="btn-text">Log In</span>
            </button>
            <Nav className="hidden-md hidden-lg navbar__forgot-password-wr">
              {this.renderForgotPasswordLink()}
            </Nav>
          </form>
        </Navbar.Form>
        <Nav className="visible-xs-block pull-right">
          <NavbarLink to="/sign-in">Sign in</NavbarLink>
        </Nav>
      </div>
    );
  }
}

NavbarLoginForm.propTypes = {
  isUserLoading: PropTypes.bool.isRequired,
  pathname: PropTypes.string,
  onSubmit: PropTypes.func.isRequired
};

NavbarLoginForm = reduxForm({
  form: 'loginForm',
  validate
})(NavbarLoginForm);

export default NavbarLoginForm;



// WEBPACK FOOTER //
// ./src/components/common/navbar/navbar-login-form.js